export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6o-d2b586b0c446f36ea26a24ebab65073e.webp";